export default {
  API_ENDPOINT: 'https://safe-ocean-62338.herokuapp.com/api',
  TOKEN_KEY: 'spaced-repetition-auth-token',
}
